<template>
    <el-card >
    <!-- 菜单树 -->
    <div style="width:50%;height:calc(100vh - 50px);overflow:auto !important">
      <el-tree
      :data="menuInfo.menuTreeData0"
      ref="tree"
      node-key="id"
      highlight-current
      :expand-on-click-node = "false"
      :default-expand-all="true"
      :props="menuInfo.defaultProps">
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span> <i :class="data.icon"></i> {{ data.label  }}</span>
          <span>
            <el-button
              type="text"
              size="small"
              icon="el-icon-edit"
              style="color:#073559"
              @click="() => editMenu(node,data)">
            </el-button>
              <el-button
              type="text"
              size="small"
              icon="el-icon-plus"
              style="color:green"
              v-if="data.level != 2"
              @click="() => addMenu(node, data)">
            </el-button>
            <el-button
              type="text"
              size="small"
              icon="el-icon-delete"
              style="color:red"
              v-if="data.level != 0 "
              @click="() => removeMenu(node, data)">
            </el-button> 
          </span>
        </span> 
      </el-tree>
    </div>
    
    <!-- 修改菜单dialog -->
    <el-dialog :visible.sync="dialogVisual.editMenuDialogVisible" v-on:close ="clearEditMneuInfoForm" >
      <div slot="title" class="dialog-footer">
        <span>菜单[{{ editMenuForm.menuName }}] 信息变更 </span>
      </div>
      <el-form :model="editMenuForm"  label-position="right" label-width="20%"> 
        <el-form-item label="菜单名称:" style="width:90%">
          <el-input v-model="editMenuForm.menuName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="访问路径:" style="width:90%">
          <el-input v-model="editMenuForm.url" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="排序编号:" style="width:90%">
          <el-input  v-model="editMenuForm.sortNum" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="图标:" style="width:90%">
          <el-select style="width:100%"  v-model="editMenuForm.icon" placeholder="请选择" >
            <el-option
              v-for="item in iconList"
              :key="item"
              :label="item"
              :value="item">
              <i :class="item"></i>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" >
        <el-button type="primary" @click="ensureChange">确定变更</el-button>
      </div>
    </el-dialog>

    <!-- 添加菜单dialog -->
    <el-dialog :visible.sync="dialogVisual.addMenuDialogVisible" v-on:close ="clearAddMenuInfoForm" >
      <div slot="title" class="dialog-footer">
          <span> 添加菜单 </span>
      </div>
      <el-form :model="addMenuInfoForm" label-width="20%"> 
        <el-form-item label="菜单名称:"  style="width:90%">
          <el-input v-model="addMenuInfoForm.menuName" autocomplete="off"  ></el-input>
        </el-form-item>
        <el-form-item label="访问地址:" style="width:90%">
          <el-input v-model="addMenuInfoForm.url" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="排序编号:" style="width:90%">
          <el-input  v-model="addMenuInfoForm.sortNum" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="图标:" style="width:90%">
          <el-select style="width:100%"  v-model="addMenuInfoForm.icon" placeholder="请选择" >
            <el-option
              v-for="item in iconList"
              :key="item"
              :label="item"
              :value="item">
              <i :class="item"></i>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="width:80%">
        <el-button type="primary" @click="ensureCreate">创建菜单</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>                     
<script>
  // 引入组件
import axios from  '@/api/axiosConfig'
import {stringIsNullOrEmpty,regCheck} from  '@/api/utils'
import {MESSAGE_DURATION,regInteger} from  '@/api/constant'
import {iconFontList} from '@/api/icon'
export default {
    name : 'pc_ctr_menu',
    data() {
    return {
      iconList :[],
      dialogVisual:{
        addMenuDialogVisible: false,
        editMenuDialogVisible: false
      },
      editMenuForm: {
        menuName: '',
        url: '',
        sortNo :'',
        id :'',
        icon:'',
        node:''
      },
      addMenuInfoForm: {
        menuName: '',
        url: '',
        sortNum: '',
        node :'',
        icon:''

      },
      menuInfo:{
        menuTreeData0: [],
        defaultProps: {
          children: 'children',
          label: 'label'
        }
      }
    }
  },
  methods : {
    // 初始化menuTree
    initMenuTree(){
      let _this = this;
      let url = "/bc/exa/menu/getMenuTree"
      let data = {}
      let s = JSON.stringify(data)
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          let resData = response.data.data
          if(resData.length !== 0){
            let rt = ''
            let levelOneList = []
            let levelTwoList = []
            resData.forEach(t=>{
              if(t.level == 0 ){
                rt = { 
                  id : t.id,
                  label : t.menuName,
                  level : t.level,
                  url : t.url,
                  sortNum : t.sortNum,
                  icon : t.icon,
                  children:[]
                }
              }else if ( t.level == 1){
                levelOneList.push(t)
              }else if(t.level == 2){
                levelTwoList.push(t)
              }
            }) 
            if(levelOneList.length !== 0){
              levelOneList.forEach(t=>{
                let datOne = { 
                  id:t.id,
                  level : t.level,
                  label: t.menuName,
                  url : t.url,
                  icon : t.icon,
                  sortNum : t.sortNum,
                  children:[]
                }
                rt.children.push(datOne)
                levelTwoList.forEach(p=>{
                  let datTwo = { 
                    id:p.id,
                    level : p.level,
                    url : p.url,
                    icon : p.icon,
                    label: p.menuName,
                    sortNum : p.sortNum
                  }
                  if(p.parentId == t.id){
                    datOne.children.push(datTwo)
                  }
                })
              })
            }
            this.menuInfo.menuTreeData0.push(rt)
          }else{
            this.$message({
              showClose: true,
              message: '未获取到数据!',
              type: 'warn',
              duration: MESSAGE_DURATION
            })
          }
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },

    // 打开添加菜单弹窗
    addMenu(node, data){
      this.dialogVisual.addMenuDialogVisible = true
      this.addMenuInfoForm.node = data 
    },

    // 创建前校验
    ensureCreate(){ 
      try{ 
        stringIsNullOrEmpty(this.addMenuInfoForm.menuName,'请输菜单名称!')
        if(this.addMenuInfoForm.node.level != 0){
          stringIsNullOrEmpty(this.addMenuInfoForm.url,'请输资源路径!')
        }
        stringIsNullOrEmpty(this.addMenuInfoForm.sortNum,'请输排序编号!')
        stringIsNullOrEmpty(this.addMenuInfoForm.icon,'请选择图标!')
        regCheck(regInteger, this.addMenuInfoForm.sortNum, '排序编号必须是正整数')
      }catch (e){
        this.$message({
          showClose: true,
          message: e,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
        return
      }
      this.doCreateMenuInfo()
    },

    // 确定校验
    doCreateMenuInfo(){
      let url = "/bc/exa/menu/addOne"
      let dat = {
        menuName: this.addMenuInfoForm.menuName,
        level: this.addMenuInfoForm.node.level + 1,
        parentId: this.addMenuInfoForm.node.id,
        sortNum: this.addMenuInfoForm.sortNum,
        url: this.addMenuInfoForm.url,
        icon : this.addMenuInfoForm.icon,
        parentMenuName: this.addMenuInfoForm.node.label
      }
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.dialogVisual.addMenuDialogVisible= false
          this.$message({
            showClose: true,
            message: '创建成功',
            type: 'success',
            duration: MESSAGE_DURATION
          })
          let res = response.data.data
          let children = [] 
          if(this.addMenuInfoForm.node.children.length !== 0){
            this.addMenuInfoForm.node.children.forEach(t=>{
              children.push(t)
            })
          }
          children.push({id : res.id,
            label : res.menuName,
            level : res.level,
            sortNum : res.sortNum,
            icon : res.icon,
            children:[]}) 
          this.$refs.tree.updateKeyChildren(this.addMenuInfoForm.node.id,children)
          this.clearAddMenuInfoForm()
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch((err)=> {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    }, 
    
    // 清空添加菜单盒子
    clearAddMenuInfoForm(){
      this.addMenuInfoForm.menuName = ''
      this.addMenuInfoForm.url =''
      this.addMenuInfoForm.sortNum = ''
      this.addMenuInfoForm.node = ''
      this.addMenuInfoForm.icon = ''
    },

    // 打开菜单编辑弹窗，回显数据
    editMenu(node,data){
      this.dialogVisual.editMenuDialogVisible = true
      this.editMenuForm.node = data 
      this.editMenuForm.menuName = data.label
      this.editMenuForm.url = data.url
      this.editMenuForm.sortNum = data.sortNum
      this.editMenuForm.id = data.id
      this.editMenuForm.icon = data.icon
    },

    // 确定变更
    ensureChange(){
      try{ 
        stringIsNullOrEmpty(this.editMenuForm.menuName,'请输菜单名称!');
        stringIsNullOrEmpty(this.editMenuForm.sortNum,'请输排序编号!');
        stringIsNullOrEmpty(this.editMenuForm.icon,'请选择图标!');
        regCheck(regInteger, this.editMenuForm.sortNum, '排序编号必须是正整数')
      }catch (e){
        this.$message({
          showClose: true,
          message: e,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
        return
      }
      let url = "/bc/exa/menu/updateOne"
      let dat = {
        menuName: this.editMenuForm.menuName,
        level: this.editMenuForm.node.level ,
        sortNum: this.editMenuForm.sortNum,
        url: this.editMenuForm.url,
        id : this.editMenuForm.id,
        icon:  this.editMenuForm.icon
      }
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.dialogVisual.editMenuDialogVisible= false
          this.$message({
            showClose: true,
            message: '修改成功',
            type: 'success',
            duration: MESSAGE_DURATION
          })
          this.$set(this.editMenuForm.node, "label",this.editMenuForm.menuName)
          this.$set(this.editMenuForm.node, "icon",this.editMenuForm.icon)
          this.$set(this.editMenuForm.node, "url",this.editMenuForm.url)
          this.$set(this.editMenuForm.node, "sortNum",this.editMenuForm.sortNum)
          this.clearEditMneuInfoForm()
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },

    // 清空编辑弹框
    clearEditMneuInfoForm(){
      this.editMenuForm.node = '' 
      this.editMenuForm.menuName = ''
      this.editMenuForm.url = ''
      this.editMenuForm.sortNum = ''
      this.editMenuForm.id = ''
      this.editMenuForm.icon = ''
    },

    // 提示删除菜单
    removeMenu(node, data){ 
      this.$confirm('即将删除菜单['+data.label+']信息', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.doRemoveNode(data)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消操作！'
        });
      })
    },

    doRemoveNode(data){
      let dat = {
        level: data.level,
        id: data.id
      }
      let s = JSON.stringify(dat)  
      let url = '/bc/exa/menu/deleteMenus';
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.$message({
            showClose: true,
            message: '操作成功',
            type: 'success',
            duration: MESSAGE_DURATION
          })
          this.$refs.tree.remove(data)
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },
  },
  created () {
    this.iconList = iconFontList
    this.initMenuTree()
  }
}
</script>
    
<style lang="less" scoped>
 .el-card {
    height: 99%
  }
  

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 20px;
}
</style>
    


// WEBPACK FOOTER //
// src/pc_pages/pc_ctr_component/pc_ctr_menu.vue